import axios from "axios";
import { store } from "../redux/store";
import { setLoading } from "../redux/features/slices/appSlice";
import { AuthApiService } from "../service/authService";
import { refreshTokenMiddleware } from "./loginAPI";

const getToken = async () => {
  const token = localStorage.getItem("accessToken");
  return token;
};

export const api = axios.create({
  baseURL: process.env.REACT_APP_BE_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

let lastRequestTime = 0;
const throttleDelay = 1000;
let loaderTimeout: NodeJS.Timeout | null = null;
let requestCount = 0;

const throttledRequest = (isRequestStart: boolean) => {
  const now = Date.now();
  if (isRequestStart) {
    requestCount++;
    if (now - lastRequestTime > throttleDelay) {
      lastRequestTime = now;
      if (loaderTimeout) clearTimeout(loaderTimeout);
      if (requestCount === 1) store.dispatch(setLoading(true));
    } else console.warn("Request throttled, skipping...");
  } else {
    requestCount--;
    if (loaderTimeout) clearTimeout(loaderTimeout);
    loaderTimeout = setTimeout(() => {
      if (requestCount === 0) store.dispatch(setLoading(false));
    }, 300);
  }
};

const excludedTokenPaths = [
  "home",
  "sign-up",
  "check-user",
  "signin",
  "logout",
];

api.interceptors.request.use(
  async (config) => {
    throttledRequest(true);

    const organizationId = localStorage.getItem("organizationId");
    console.log(
      "API Interceptor - organizationId from localStorage:",
      organizationId
    );

    const shouldExcludeToken = excludedTokenPaths.some((path) =>
      config.url?.includes(path)
    );

    if (
      config.headers &&
      config.headers["Content-Type"] === "application/json"
    ) {
      config.headers.organizationId = organizationId;
      console.log(
        "API Interceptor - Setting organizationId header:",
        organizationId
      );
    }

    if (!shouldExcludeToken) {
      const token = await getToken();

      if (
        config.headers &&
        config.headers["Content-Type"] === "application/json"
      ) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    throttledRequest(false);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    throttledRequest(false);
    return response;
  },
  async (error) => {
    throttledRequest(false);
    const originalRequest = error.config;
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403) &&
      !originalRequest._retry &&
      !originalRequest.url.includes("/refresh-token")
    ) {
      originalRequest._retry = true;
      try {
        const newAccessToken = await refreshTokenMiddleware();
        if (newAccessToken) {
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);
